import {
  getPayInfo,
  setAddressId,
  setPayInfo
} from '@/utils/Address.js'

const storageGoodsInfo = {
  payInfo: [],
  payType: ''
}


// 设置优惠券
const Set_welfareCard = (state, info) => {
  state.welfareCard = info
}

// 清空优惠券
const clearWelfareCard = (state) => {
  state.welfareCard = {}
}

// 设置订单号
const Set_orderId = (state, info) => {
  state.orderId = info
}


const mutations = {
  SET_ADDRESSID: (state, addressId) => {
    console.log(addressId);
    
    if (addressId) {
      setAddressId(addressId)
      state.addressId = addressId
    }
  },
  GET_ADDRESSID: state => {
    return state.addressId
  },
  CLEAN_ADDRESSID: state => {
    state.addressId = ''
  },
  // 设置支付信息
  /**
   * @typedef {Object} payInfo
   * @property {Array} payInfo - 支付信息
   * @property {String} payType - 支付类型 cart 购物车结算 buyNow 立即购买结算
   */
  SET_PAYINFO: (state, info) => {
    const { payInfo, payType } = info

    if (payInfo && payType) {
      state.payInfo = payInfo
      state.payType = payType

      storageGoodsInfo.payInfo = payInfo
      storageGoodsInfo.payType = payType

      setPayInfo(storageGoodsInfo)
    }
  },
  Set_welfareCard,
  clearWelfareCard,
  Set_orderId
}

export default mutations
